import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import {connect} from 'react-redux';
import {window} from 'ssr-window';
import DOMUtils from '@spothero/utils/dom';
import {SEARCH_TYPE} from '../search-prop-types';
import AddressFeatureDesktop from '../features/AddressFeatureDesktop';
import DestinationFeatureDesktop from '../features/DestinationFeatureDesktop';
import EventFeatureDesktop from '../features/EventFeatureDesktop';
import CityFeatureDesktop from '../features/CityFeatureDesktop';
import {getPriceRange} from 'filters/filters-selectors';
import {toggleInfoPanelView} from '../search-actions';

class SpotListFeatureDesktop extends Component {
    static propTypes = {
        spots: PropTypes.arrayOf(PropTypes.object).isRequired,
        searchType: SEARCH_TYPE.isRequired,
        isFetchComplete: PropTypes.bool.isRequired,
        isInfoPanelVisible: PropTypes.bool,
        isMonthly: PropTypes.bool,
        showEventList: PropTypes.bool,
        city: PropTypes.object.isRequired,
        destination: PropTypes.shape(DESTINATION_DATA).isRequired,
        breadcrumbs: PropTypes.object,
        event: PropTypes.object,
        lowPrice: PropTypes.number.isRequired,
        highPrice: PropTypes.number.isRequired,
        toggleInfoPanel: PropTypes.func.isRequired,
        onToggleEventList: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this._hasSmallWindow = window.innerWidth < 900; // uses breakpoint-md value of 900
    }

    componentDidMount() {
        if (this._hasSmallWindow) {
            this.props.toggleInfoPanel(false);
        }
    }

    _onShowInfoPanel = () => {
        const {isInfoPanelVisible, toggleInfoPanel} = this.props;

        if (isInfoPanelVisible) {
            const infoPanel = DOMUtils.el('.InfoPanel-container');

            DOMUtils.addClass(infoPanel, 'highlight');

            setTimeout(() => {
                DOMUtils.removeClass(infoPanel, 'highlight');
            }, 3000);
        }

        if (this._hasSmallWindow) {
            const pageContainer = DOMUtils.el('.search-page');

            DOMUtils.addClass(pageContainer, 'info-panel-hidden');
        }

        toggleInfoPanel(true);
    };

    render() {
        const {
            spots,
            breadcrumbs,
            searchType,
            city,
            destination,
            event,
            showEventList,
            lowPrice,
            highPrice,
            isFetchComplete,
            isMonthly,
            onToggleEventList,
        } = this.props;
        const commonProps = {
            breadcrumbs,
            city,
            destination,
            event,
            isFetchComplete,
            numSpots: spots.length,
            lowPrice,
            highPrice,
            isMonthly,
        };

        return (
            <div className="SpotListFeature">
                {searchType === 'address' && (
                    <AddressFeatureDesktop {...commonProps} />
                )}
                {(searchType === 'destination' || searchType === 'venue') && (
                    <DestinationFeatureDesktop
                        {...commonProps}
                        showEventList={showEventList}
                        onShowInfoModal={this._onShowInfoPanel}
                        onToggleEventList={onToggleEventList}
                    />
                )}
                {searchType === 'event' && (
                    <EventFeatureDesktop
                        {...commonProps}
                        onShowInfoModal={this._onShowInfoPanel}
                    />
                )}
                {searchType === 'city' && (
                    <CityFeatureDesktop
                        {...commonProps}
                        onShowInfoModal={this._onShowInfoPanel}
                    />
                )}
            </div>
        );
    }
}

const makeMapStateToProps = () => state => {
    const {
        search: {
            data: {breadcrumbs, searchType, isInfoPanelVisible},
        },
        city: {data: city},
        destination: {data: destination},
        event: {data: event},
        spots: {isPending: areSpotsLoading},
        searchRequest: {monthly: isMonthly},
    } = state;
    const {priceLow: lowPrice, priceHigh: highPrice} = getPriceRange(state);

    return {
        breadcrumbs,
        city,
        destination,
        event,
        searchType,
        isMonthly,
        isInfoPanelVisible,
        lowPrice,
        highPrice,
        isFetchComplete: !areSpotsLoading,
    };
};

const mapDispatchToProps = {
    toggleInfoPanel: toggleInfoPanelView,
};

export default connect(
    makeMapStateToProps,
    mapDispatchToProps
)(SpotListFeatureDesktop);
